import { useQuery } from "@tanstack/react-query";
import { configKeys } from "@/lib/query";

interface AppConfig {
  demoMode: boolean;
  environment: string;
  version: { major: number; minor: number; commit: string };
}

export function useConfig() {
  return useQuery({
    queryKey: configKeys.all,
    queryFn: async (): Promise<AppConfig> => {
      const res = await fetch("/api/config");
      return res.json() as Promise<AppConfig>;
    },
    staleTime: Number.POSITIVE_INFINITY,
  });
}
